let timer = null;
let debounceRunning = false;
const DEBOUNCE_TIME = 750;
const MIN_TEXT_LENGTH = 3;

export const debounce = function(text, debounceTime = DEBOUNCE_TIME, minTextLength = MIN_TEXT_LENGTH) {
  if (debounceRunning || text.length < minTextLength) return Promise.resolve(false);

  debounceRunning = true;
  return new Promise((resolve) => {
    if (timer === null) {
      timer = setTimeout(() => {
        clearTimeout(timer);
        timer = null;
        debounceRunning = false;
        resolve(true);
      }, debounceTime);
    }
  });
}